import { I18N_BASE } from '../constants';
import { SubjectKind } from '../models';

// Shape that both QueueListItem and ModerationEvent satisfy. We don't constrain
// to a specific named type so the helper works for cluster items + review event
// + any future shape that carries the same subject fields.
export interface SubjectIdSource {
  subjectKind: SubjectKind | null | undefined;
  fundraiserId?: number | null;
  teamId?: number | null;
  collectionId?: number | null;
}

export interface SubjectIdSegment {
  i18nKey: string;
  id: number;
}

// The queue endpoint populates exactly one of fundraiserId/teamId/collectionId
// per row (matching subjectKind). Surface that ID wherever we list events so
// reviewers can cross-reference it with other admin tools. Blobs have no
// subject ID — they're identified by blobPath instead.
export function subjectIdSegment(item: SubjectIdSource): SubjectIdSegment | null {
  switch (item.subjectKind) {
    case 'fundraiserPage':
      return item.fundraiserId != null
        ? { i18nKey: `${I18N_BASE}.queue.card.subjectId.fundraiser`, id: item.fundraiserId }
        : null;
    case 'teamPage':
      return item.teamId != null
        ? { i18nKey: `${I18N_BASE}.queue.card.subjectId.team`, id: item.teamId }
        : null;
    case 'collectionPage':
      return item.collectionId != null
        ? { i18nKey: `${I18N_BASE}.queue.card.subjectId.collection`, id: item.collectionId }
        : null;
    case 'blob':
    default:
      return null;
  }
}
